import React, { useState, createContext, useContext } from "react";

// Create Context Object
const SettingsContext = createContext();

// Create a provider for components to consume and subscribe to changes
const SettingsProvider = (props) => {
	const [settings, setSettings] = useState({
		style: "mapbox://styles/devola-sewer/cldni9c66002v01rx7zy9w2xi/draft",
		apiKey: "pk.eyJ1IjoiZGV2b2xhLXNld2VyIiwiYSI6ImNsZG5kMnJxNTBjZjUzcnFlM2ppYmFvM2oifQ.0VJTciKr_sGJjJA1ju3aXg",
		// sw, ne coordinates of desired view
		initialViewState: {
			latitude: 39.472073,
			longitude: -81.475666,
			zoom: 15
			// centerPoint: {
			//   latitude: 40.283761,
			//   longitude: -89.045149,
			// },
		},
		interactiveLayerIds: ['devola-sewer-row-permanent', 'devola-sewer-alignment', 'devola-project-boundary-2022-v2', 'devola-sewer-laterals']
	});

	return <SettingsContext.Provider value={[settings, setSettings]}>{props.children}</SettingsContext.Provider>;
};

const useSettings = () => {
	const context = useContext(SettingsContext);
	if (context === undefined) {
		throw new Error('useSettings must be used within a SettingsProvider');
	}
	return context;
}

export { SettingsProvider, SettingsContext, useSettings }